import * as toastr from "toastr";
import { State } from "source/app/services/UI/State/State";
import { IGoalsContainerState } from "source/app/presentation/MainPanel/Goals/IGoalsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { goalsService } from "motw_core/Services/GoalsService";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import {
    OnErrorAddLogEntry,
    OnFinishAddLogEntry,
} from "source/app/services/Log/AddEntry";
import { logRepository } from "motw_core/Repositories/LogRepository";

export async function LogDailyGoalForCICOWeightAsync() {
    const goalsContainer = State.ReadClass<IGoalsContainerState>(
        ESharedComponent.GoalsContainer
    );

    const matchingGoal = goalsContainer.state.Goals.find(
        (goal) => goal.name.toLowerCase() === `measureweight`
    )!;

    await logRepository.AddOneTimeLogEntryAsync(
        matchingGoal.verb,
        matchingGoal.name,
        ClientDataProvider,
        OnErrorAddLogEntry,
        OnFinishAddLogEntry
    );

    toastr.info(`logged entry for goal '${matchingGoal.name}'`);
    Data.Load.AllAsync();
}
